module.exports = __webpack_public_path__ + "img/ssb_menu5.5066cfc9.png";